const PATH = '/location/:f([a-z0-9-]{0,}?)?-:locationId([a-z0-9]{6,})';

export default {
  path: PATH,

  load: (context: any, params: any) => import(/* webpackChunkName: 'location' */ './index'),
};
